/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Thread } from './Thread';
import {
    ThreadFromJSON,
    ThreadFromJSONTyped,
    ThreadToJSON,
    ThreadToJSONTyped,
} from './Thread';

/**
 * 
 * @export
 * @interface ListThreadsResponse
 */
export interface ListThreadsResponse {
    /**
     * 
     * @type {Array<Thread>}
     * @memberof ListThreadsResponse
     */
    threads: Array<Thread>;
}

/**
 * Check if a given object implements the ListThreadsResponse interface.
 */
export function instanceOfListThreadsResponse(value: object): value is ListThreadsResponse {
    if (!('threads' in value) || value['threads'] === undefined) return false;
    return true;
}

export function ListThreadsResponseFromJSON(json: any): ListThreadsResponse {
    return ListThreadsResponseFromJSONTyped(json, false);
}

export function ListThreadsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListThreadsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'threads': ((json['threads'] as Array<any>).map(ThreadFromJSON)),
    };
}

export function ListThreadsResponseToJSON(json: any): ListThreadsResponse {
    return ListThreadsResponseToJSONTyped(json, false);
}

export function ListThreadsResponseToJSONTyped(value?: ListThreadsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threads': ((value['threads'] as Array<any>).map(ThreadToJSON)),
    };
}

